import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { FormField } from '../../../interfaces/form.interface';
import { DropdownData, FilteredValue, InputType } from '../../../interfaces/input.interface';

@Component({
    selector: 'app-reactive-select-field',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './select-field.component.html',
})
export class ReactiveSelectFieldComponent<T> {
    @Input() field!: FormField<T>;

    @Input() model!: FormGroup;

    @Input() isEditable = false;

    @Input() describedById = '';

    @Input() isInvalid = false;

    @Input() filterInputParcelas = false;

    public readonly inputType = InputType;

    public get filteredOptions(): FilteredValue<T>[] {
        return (this.field?.input?.data as DropdownData<T>).filtered ?? [];
    }

    public updateModel(): void {
        if (!this.field.input?.selectButtonConfiguration?.onClick) {
            return;
        }

        const onClick = this.field.input.selectButtonConfiguration.onClick(this.field as T);

        onClick.then((data) => {
            Object.entries(data).forEach(([key, value]) => {
                this.model.patchValue({ [key]: value });
            });

            return;
        }).catch((error: string) => {
            console.log(error);
        });
    }
}
